import ProductModelPanel from './productModelPanel.container';

export default ProductModelPanel;